import React, { Component } from 'react'
import { base } from '../../base';
import SideMenu from '../admin/SideMenu';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import '../../styles/css/AdminMain.css'

class SetUpVoting extends Component {
    constructor(props) {
        super(props);

        this.state = {
          companyList: [],
          selectedCompany: {},
          companyVotingState: false,
          modal: false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    componentWillMount() {
      this.companyListRef = base.syncState(`companyList`, {
        context: this,
        state: 'companyList',
        asArray: true
      });
      this.companyVotingOnRef = base.syncState(`companyVotingOn`, {
        context: this,
        state: 'companyVotingState'
      });
      // this.votingOverRef = base.syncState(`votingOver`, {
      //   context: this,
      //   state: 'votingOver'
      // });
    }

    componentWillUnmount() {
      base.removeBinding(this.companyListRef);
      base.removeBinding(this.companyVotingOnRef);
      // base.removeBinding(this.votingOverRef);
    }

    handleSubmit(event) {
      event.preventDefault();
      const data = new FormData(event.target)
      var companyTitle = data.get('companyTitle');
      if(!companyTitle){
        alert("Missing Field!")
        return;
      }
      var selectedCompany = this.state.selectedCompany;
      if(Object.keys(selectedCompany).length === 0){
        selectedCompany = null;
      }
      var vm = this;
      //check if editing company or not
      if(!selectedCompany){
        base.push('companyList', {
          data: {companyTitle: companyTitle, votes: 0},
          then(err){
            if(!err){
              document.getElementById("create-company-form").reset();
              vm.setState({
                selectedCompany: {},
              })
            }
          }
        })
      } else {
        var selectedCompanyId = selectedCompany.key;
        base.post(`companyList/${selectedCompanyId}/companyTitle`, {
          data: companyTitle,
          then(err){
            if(!err){
              document.getElementById("create-company-form").reset();
              vm.setState({
                modal: false,
                selectedCompany: {},
              });
            }
          }
        });
      }
      // //available immediately, you don't have to wait for the callback to be called
      // var generatedKey = immediatelyAvailableReference.key;
    }

    editCompany(event){
      event.preventDefault();
      var array = this.state.companyList;
      var company = array[event.target.value];
      this.setState({
        modal: true,
        selectedCompany: company,
      });
    }

    setVotingActive(e){
      e.preventDefault();
      this.setState({
        companyVotingState: !this.state.companyVotingState,
        selectedCompany: {},
      });
      if(this.state.companyVotingState){
        base.post('finalCompanyList', {
          data: this.state.companyList,
          then(err){
            if(err){
              alert(err);
            }
          }
        })
      }
    }

    clearOldVotes(e){
      e.preventDefault();
      var array = this.state.companyList;
      var updateObject = {};
      //eslint-disable-next-line
      var result = confirm("Remove company votes?");
      if(result){
        for(var company in array){
          updateObject["companyList/" + array[company].key + "/votes"] = 0;
        }
        updateObject['finalCompanyList'] = null
        base.update('/', {
          data: updateObject,
          then(err){
            if(!err){
              alert("Votes Wiped!")
              //bears endpint is now {name: 'George', type: 'Grizzly'}
            }
          }
        })
      }
    }

    deleteCompany(e){
      e.preventDefault();
      var array = this.state.companyList;
      var index = array[e.target.value];
      //eslint-disable-next-line
      var result = confirm("Delete company?");
      if (result) {
        base.remove('companyList/' + index.key, function(err) {
          if(err){
            alert("Something went wrong!")
          }
        })
      }
    }

    toggle() {
      this.setState({
        modal: !this.state.modal,
        selectedCompany: {},
      });
    }

    render() {
      var editCompanyTitle = ""
      var currentVotingState = this.state.companyVotingState;
      var selectedCompany = this.state.selectedCompany;
      if(Object.keys(selectedCompany).length === 0){
        selectedCompany = null;
      } else {
        editCompanyTitle = selectedCompany.companyTitle;
      }
      if(this.state.companyList){
        var companyArray = this.state.companyList;
      }

        return (
          <div className="admin-wrapper">
            <SideMenu/>
            <div className="admin-main-panel">
                <h1>Set Up Voting</h1>
                <div className="admin-grid-container two-columns">
                  {
                    currentVotingState ? (
                      <Button className="btn btn-default btn-admin btn-create-question" onClick={this.setVotingActive.bind(this)}>End Voting Session</Button>
                    ) : (
                      <Button className="btn btn-default btn-admin btn-create-question" onClick={this.setVotingActive.bind(this)}>Start Voting Session</Button>
                    )
                  }
                  {/*{
                    votingOver ? (
                      <Button className="btn btn-default btn-admin btn-create-question" onClick={this.toggleVotingOver.bind(this)}>HIDE TOTAL COMPANY VOTES</Button>
                    ) : (
                      <Button className="btn btn-default btn-admin btn-create-question" onClick={this.toggleVotingOver.bind(this)}>SHOW TOTAL COMPANY VOTES</Button>
                    )
                  }*/}
                  <Button className="btn btn-default btn-admin btn-create-question" onClick={this.toggle}>New Company <i className="fa fa-plus" aria-hidden="true"></i></Button>
                  <Button className="btn btn-default btn-admin btn-create-question" onClick={this.clearOldVotes.bind(this)}>Clear Company Votes</Button>
                </div>
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                  <ModalHeader toggle={this.toggle}>Edit Company</ModalHeader>
                    <ModalBody>
                      <div className="container-out">
                        <div className="question-box question-form">
                          <form onSubmit={this.handleSubmit} id="create-company-form">
                            <div className="form-group">
                              <label htmlFor="companyTitle">Enter Company Name: </label>
                              <input id="companyTitle" name="companyTitle" type="text" className="form-control" defaultValue={editCompanyTitle}/>
                            </div>
                            <button className="btn btn-default btn-admin">Submit</button>
                          </form>
                        </div>
                      </div>
                    </ModalBody>
                    <ModalFooter>
                      <Button color="secondary" onClick={this.toggle}>Close</Button>
                    </ModalFooter>
                </Modal>
              <h2 className="lines-on-sides">Companies</h2>
              {
                  <div className="admin-grid-container">
                  {
                    companyArray.map(function(item,i){
                      return <div key={i} className="question-box">
                          <p className="company-title"><strong>{item.companyTitle}</strong></p>
                          <button className="btn btn-default btn-admin" onClick={this.editCompany.bind(this)} value={i}>EDIT</button>
                          <button className="btn btn-default btn-admin" onClick={this.deleteCompany.bind(this)} value={i}>DELETE</button>
                        </div>
                    }, this)
                  }
                  </div>
              }
            </div>
         </div>
        );
    }
}

export default SetUpVoting



// WEBPACK FOOTER //
// ./src/components/admin/SetUpVoting.js